import React from 'react';
import { experience } from '../../data/portfolioData';

const ExperienceSection = () => (
  <section className="experience-section" id="experience">
    <div className="section-header">
      <span className="section-meta">Experience</span>
      <h2 className="section-title">Work Experience</h2>
    </div>
    <div className="timeline">
      {experience.map(exp => (
        <div key={exp.id} className="timeline-item">
          <div className={`timeline-dot ${exp.colorClass}`} />
          <p className="timeline-period"><i className="fas fa-calendar-alt" style={{marginRight:6}}></i>{exp.period}</p>
          <h3 className="timeline-role">{exp.role}</h3>
          <p className="timeline-company">
            <a href={exp.companyUrl} target="_blank" rel="noreferrer">{exp.company}</a>
          </p>
          <ul className="timeline-points">
            {exp.points.map((pt, i) => <li key={i}>{pt}</li>)}
          </ul>
        </div>
      ))}
    </div>
  </section>
);

export default ExperienceSection;
